import React, { useCallback, useEffect } from 'react';

import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import UsersListBig from '../../../../components/reusable/users-list/UsersListBig';
import {
  useGetMyDetails,
  useLazyGetUserSubscribers,
} from '../../../../redux/api/users/usersApi';

export default function MySubscribers() {
  const { data: user, isFetching: isFetchingUser } = useGetMyDetails();
  const [getUserSubscribers, { data: userSubscribers, isError, error }] =
    useLazyGetUserSubscribers();

  useEffect(() => {
    if (user) {
      getUserSubscribers(user.id);
    }
  }, [user?.id]);

  const refreshList = useCallback(() => {
    if (user?.id) void getUserSubscribers(user.id);
  }, [user?.id, getUserSubscribers]);

  const isListLoading =
    Boolean(isFetchingUser) || !user || userSubscribers === undefined;

  useRegisterPageContainerError({
    errors: isError && error ? [error] : [],
    isLoading: isListLoading,
    hasData: Boolean(userSubscribers),
    onRetry: refreshList,
  });

  return (
    <UsersListBig
      users={userSubscribers}
      showSearch
      isLoading={isListLoading}
      isError={isError}
    />
  );
}
